module.exports = __webpack_public_path__ + "media/assets/svg/illustrations/undraw_online_collaboration-a20d0a335b5c1395f77e88e5254c1106.svg";